import React from 'react'
import { SchoolAnswer, Step } from '../../components'
import { useOnboarding } from '../../context'

export const School = ({ index }) => {
  const { state } = useOnboarding()
  const schoolOrOrganisation = React.useMemo(() => {
    return state.survey.role[0].value === 'other' ? 'organisation' : 'school'
  }, [state.survey.role[0].value])

  return (
    <Step
      key={'School-school'}
      trackingKey={`${schoolOrOrganisation}_name`}
      index={index}
      itemsCount={1}
      mode='finish'
      title={`Tell us your ${schoolOrOrganisation} name`}
      subtitle={`Search for your ${schoolOrOrganisation} name below (Required)`}
    >
      <SchoolAnswer />
    </Step>
  )
}
